define('models/city',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                name: '',
                country: 0
            };
        }
    });
});
